import PayeeInfo from './PayeeInfo';

export default PayeeInfo;
